// 平台认证为 Bearer token（见 src/api/axios.js），子应用资源与接口不依赖 cookie：
// 显式 omit 防止请求携带 cookie；若某部署依赖 cookie 登录态，需改为 include，
// 并要求子应用服务端返回 Access-Control-Allow-Credentials 且 Origin 不能为 *
export default function fetch(url, options) {
  return window.fetch(url, { ...options, credentials: 'omit' })
}
